import {
  Grid,
  TextField,
  Box,
  useTheme,
  Button,
  Typography,
} from "@mui/material";
import SetupGuide from "../../../../src/components/SetupGuide";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../../components/Header";
import { tokens } from "../../../theme";
import Alert from "@mui/material/Alert";

const SiteDetails = ({
  register,
  errors,
  onChangeSelectedApplication,
  selectedApplication,
  onHandleNftTokenGatingInputChange,
  nftTokenGatingInputFields,
  setupGuide,
  errorMessage,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const colors = tokens(theme.palette.mode);

  const gotoPreviousPage = () => {
    navigate("/token-gating");
  };

  return (
    <Box mt="40px" ml="60px">
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Header title="Site Details" subtitle="Fill the required field" />
        <SetupGuide url={process.env.REACT_APP_GENERAL_SETUP_GUIDE} />
      </Box>

      <Grid container spacing={3}>
        <Grid item md={10.6} xs={10.6} sm={10.6}>
          <Typography
            component="h6"
            variant="h5"
            color={colors.greenAccent[400]}
            fontFamily="Helvetica Neue"
            sx={{}}
          >
            Selected Application
          </Typography>
          <TextField
            fullWidth
            value={location.state}
            sx={{ mt: 2, boxShadow: 2 }}
          />
        </Grid>
        <Grid item md={1} xs={1} sm={1}>
          <Button
            className="custom-color-button"
            size="small"
            variant="contained"
            color="info"
            sx={{ mt: 6, ml: 1, minWidth: "68px" }}
            onClick={gotoPreviousPage}
          >
            Edit App
          </Button>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            name="domainName"
            label="Enter the domain name without http or https. Example: www.abc.com "
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={nftTokenGatingInputFields.domainName}
            onChange={onHandleNftTokenGatingInputChange}
            required
          />
        </Grid>
        {errorMessage.domainName && (
          <Typography color="red" fontSize="14" sx={{ ml: 3.5, mt: 0.5 }}>
            Please Provide a valid Domain.
          </Typography>
        )}
        <Grid item xs={12}>
          <TextField
            name="serverUrl"
            label="Server Url"
            variant="outlined"
            type="text"
            fullWidth
            required
            sx={{ boxShadow: 2 }}
            value={nftTokenGatingInputFields.serverUrl}
            onChange={onHandleNftTokenGatingInputChange}
          />
        </Grid>
        {errorMessage.serverUrl && (
          <Typography color="red" fontSize="14" sx={{ ml: 3.5, mt: 0.5 }}>
            {errorMessage.serverUrlMessage}
          </Typography>
        )}

        <Grid item xs={12}>
          <Alert severity="info" sx={{ fontFamily: "Poppins" }}>
            Open terminal then ping domainName to know Server Url Example ping
            <stong> www.example.com</stong>
          </Alert>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SiteDetails;
